import {set_class} from 'lib/utilities';

export default function ToggleClass(selector = '.toggle-class') {
    let models = [];

    update();

    function add_events() {
        models.forEach(add_model_event);
    }

    function remove_events() {
        models.forEach(remove_model_event);
    }

    function add_model_event(model) {
        model.element.addEventListener('click', on_model_click);
    }

    function remove_model_event(model) {
        model.element.removeEventListener('click', on_model_click);
    }

    function on_model_click(event) {
        const model = find_matching_model(event.currentTarget);

        toggle_model(model);
    }

    function find_matching_model(element) {
        for (const model of models) {
            if (model.element === element) {
                return model;
            }
        }
    }

    function find_elements() {
        return Array.from(document.querySelectorAll(selector));
    }

    function find_models() {
        return find_elements().map(element_to_model);
    }

    function element_to_model(element) {
        const targetSelector = element.getAttribute('data-target');
        const target = document.querySelector(targetSelector);
        const className = element.getAttribute('data-class');

        return {
            element,
            target,
            class: className
        }
    }

    function toggle_model(model) {
        set_class(model.target, model.class, ! model.target.classList.contains(model.class));
    }

    function update_models() {
        models = find_models();
    }

    function update() {
        remove_events();
        update_models();
        add_events();
    }

    function destroy() {
        remove_events();
        models = [];
    }

    return {
        update,
        destroy
    }
}